import { Component, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { lang_shedule } from 'app/idiomas/i18n/shedule/shedule.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-programacion',
  templateUrl: './programacion.component.html',
  styleUrls: ['./programacion.component.scss']
})
export class ProgramacionComponent implements OnInit {

  @ViewChild('pasos') pasos: MatStepper;

  enviaDatosEditor: Subject<any> = new Subject<any>();

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    lang_shedule.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
  }

  cambiaPaso(numero:number){
    this.pasos.selectedIndex = numero;
  }

  enviaInfoEditor(datos:any) {
    this.enviaDatosEditor.next(datos);
  }

}
